var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-panel"},[_c('div',{staticClass:"home-panel-container"},[_c('div',{staticClass:"img-container"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.background}})]),_c('div',{staticClass:"home-panel-caption"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }